var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('swiper',{staticClass:"home-swiper"},_vm._l((_vm.cbanners),function(item){return _c('swiper-item',{key:item.acm},[_c('div',{staticClass:"index-swiper"},[_c('img',{attrs:{"src":item.image,"alt":""},on:{"load":_vm.imageLoad}})])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }